import styled from 'styled-components';
import { Flex } from '.';
import {gallery54} from "../variables";

export default styled(Flex).attrs({className: 'pl-3'})`
    background-color: ${gallery54};
    width: 343px;
`;

